






































import * as util from '../../../util'
import attach from './attach.vue'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
@Component({
  components: { attach },
})
export default class Weibo extends Vue {
  @Prop() weibo: any
  images: any = []
  OSSThumbImg: string = 'x-oss-process=image/resize,w_400'
  imagePreview() {}
  async imageList() {
    if (this.weibo.image_urls) {
      let images = []
      for (let item in this.weibo.image_urls) {
        let a = {
          src: '',
          msrc: '',
          w: 0,
          h: 0,
        }
        let image = (await util.loadImage(item)) as any
        a.src = item
        a.msrc = `${item}`
        a.w = image.width
        a.h = image.height
        images.push(a)
      }
      this.images = [...this.images, ...images]
    }
  }

  @Watch('weibo')
  onWeiboChanged() {
    this.imageList()
  }
}
